import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Sidebar from './Components/SideBar';
import { SidebarProvider } from './SidebarContext';
import ActivityLog from './Components/ActivityLog';
import EmployeePerformance from './Components/EmployeePerformance';
import Salaries from './Components/Salaries';
import Dashboard from './Components/Dashboard';
import ReceivedPayment from './Components/ReceivedPayment';
import DuePayment from './Components/DuePayment';
import Offerings from './Components/Offering';
import Onboarding from './Components/Onboarding';
import AllUsers from './Components/AllUsers';
import UserRecords from './Components/UserRecords';
import ClassAgeGroup from './Components/ClassAgeGroup';
import ClassLevels from './Components/ClassLevels';
import ClassSchedule from './Components/ClassSchedule';
import TeamDepartment from './Components/TeamDepartment';
import TeamDirectory from './Components/TeamDirectory';
import TeamAttendance from './Components/TeamAttendance';
import Plan from './Components/Plan';
import Branch from './Components/Branch';
import Updates from './Components/Updates';
import Equipments from './Components/Equipments';
import Renewals from './Components/Renewals';
import Category from './Components/Category';
import Pincode from './Components/Pincode';
import Delivery from './Components/Delivery';
import Coupon from './Components/Coupon';
import Orders from './Components/Orders';
import Location from './Components/Location';
import AddTimeLog from './Components/AddTimeLog';
import TimeLog from './Components/TimeLog';
import SalaryDetail from './Components/SalaryDetail';
import Gallery from './Components/Gallery';
import Login from './Components/Login';
import UserRecordSuper from './Components/UserRecordSuper';
import { ToastContainer } from 'react-toastify';
import LeadsUpdated from './Components/Leads/LeadsUpdated';
import Slider from './Components/Slider';
import PropertyCategory from './Components/PropertyCategory';
import PropertyForm from './Components/PropertyForm';
import MyProperty from './Components/MyProperty';
import Amenities from './Components/Amenities';
import LocationAdvantage from './Components/LocationAdvantage';
import ProtectedRoute from './Components/ProtectedRoute';
import NotFound from './Components/NotFound';
import Slider2 from './Components/Slider2'
import PropertyCategoryUpdate from './Components/PropertyCategoryUpdated';
import MyProjectUpdated from './Components/MyProjectUpdated';
import AmenitiesUpdatedTable from './Components/AmenitiesUpdatedTable';
import LocationAdvantageUpdated from './Components/LocationAdvantageUpdated';
import LeadsUpdatedVersion from './Components/LeadsUpdatedVersion/LeadsUpdatedVersion';
import LoanEMICalculator from './Components/LoanEMICalulator';
import WaterSupply from './Components/WaterSupply';
import Security from './Components/Security';
import ResidentPropertyForm from './Components/ResidentPropertyForm';
import RentPropertyForm from './Components/RentPropertyForm';
import CommercialPropertyForm from './Components/CommercialPropertyForm';
import ResidentPropertyEdit from './Components/ResidentPropertyEdit';
import ResidentRentEdit from './Components/RentResidential';
import CommercialEdit from './Components/CommercialEdit';
import Feedback from './Components/Feedback';
import Schedule from './Components/Schedule';
import Marquee from './Components/Marquee/Marquee';
import ResetPassword from './Components/ResetPassword';
import Department from './Components/Department/Department';
import Customer from './Components/CustomerDetails/Customer';
import CustomerImport from './Components/CustomerDetails/CustomerImport';
import Export from './Components/Invoice/export';
import Invoice from './Components/Invoice/Invoice';
import NewInvoice from './Components/Invoice/NewInvoice';
import InvoiceImport from './Components/Invoice/InvoiceImport';
import InvoicePdf from './Components/Invoice/InvoicePdf';
import Expenses from './Components/Expense/Expense';
import AddCustomer2 from './Components/CustomerDetails/AddCustomer2';
import AddCustomer3 from './Components/CustomerDetails/AddCustomer3';
import axios from 'axios';
import ExportCustomer from './Components/CustomerDetails/exportcustomer';
import { listenToForegroundMessages, requestFCMToken } from './Components/utils/firebaseUtils';
import TeamAttendanceSingle from './Components/TeamAttendanceSingle';
import Commission from './Components/Commission/Commission';



const App = () => {
    const location = useLocation();
    const url = process.env.REACT_APP_LINK
    const login = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh"));
    const userLoggedIn = login && login.user_id;
    const hideSidebarRoutes = ['/login', '/register'];
    const shouldHideSidebar = hideSidebarRoutes.includes(location.pathname) || !userLoggedIn;

    const fetchData = async () => {
        try {
            const response = await axios.get(`${url}/auth/single/${login.user_id}`);
            // setProfile(response.data);
            localStorage.setItem("2xgxgshdugyywerw12gh", JSON.stringify(response.data))
        } catch (error) {
            console.error('Error fetching location:', error);
        }
    }

    const [fcmToken, setfcmToeken] = useState(null);


    useEffect(() => {
        const fetchFcmToken = async () => {
            try {
                const token = await requestFCMToken()
                console.log(token)
                setfcmToeken(token);
            } catch (error) {
                console.error("error getting token ", error)
            }
        }
        fetchFcmToken();
        listenToForegroundMessages();
    }, [])

    useEffect(() => {
        if (fcmToken && userLoggedIn) {
            const saveToken = async () => {
                try {
                    await axios.post(`${url}/firebase/register-token`, {
                        user_id: login.user_id,
                        deviceToken: fcmToken
                    });
                    console.log("FCM token saved");
                } catch (error) {
                    console.error("Failed to save FCM token:", error);
                }
            };
            saveToken();
        }
    }, [fcmToken, userLoggedIn]);

    useEffect(() => {
        fetchData();
    }, [])

    return (
        <SidebarProvider>
            <div className="app-container">
                {/* Sidebar is always rendered */}
                {!shouldHideSidebar && <Sidebar />}
                {/* Main content area */}
                <div className={`main-content ${shouldHideSidebar ? 'full-width' : ''}`}>
                    <Routes>
                        <Route path="/customer" element={<ProtectedRoute><Customer /></ProtectedRoute>} />
                        <Route path="/customer-import" element={<ProtectedRoute><CustomerImport /></ProtectedRoute>} />
                        <Route path="/export" element={<ProtectedRoute><Export /></ProtectedRoute>} />
                        <Route path="/invoice" element={<ProtectedRoute><Invoice /></ProtectedRoute>} />
                        <Route path="/new-invoice" element={<ProtectedRoute><NewInvoice /></ProtectedRoute>} />
                        <Route path="/invoice-import" element={<ProtectedRoute><InvoiceImport /> </ProtectedRoute>} />
                        <Route path="/invoice-pdf/:order_number" element={<ProtectedRoute> <InvoicePdf /></ProtectedRoute>} />
                        <Route path="/edit-invoice/:id" element={<ProtectedRoute><NewInvoice isEditMode={true} /></ProtectedRoute>} />
                        <Route path="/export-customer" element={<ProtectedRoute><ExportCustomer /></ProtectedRoute>} />
                        {/* <Route path="/" element={<Dashboard />} />
                        <Route path="/customer" element={<Customer />} /> */}
                        {/* <Route path="/customer-import" element={<CustomerImport />} />
                        <Route path="/add-customer" element={<AddCustomer />} /> */}
                        {/* <Route path="/export" element={<Export />} />
                        <Route path="/invoice" element={<Invoice />} />
                        <Route path="/new-invoice" element={<NewInvoice />} />
                        <Route path="/invoice-import" element={<InvoiceImport />} />
                        <Route path="/activity-log" element={<ActivityLog />} />
                        <Route path="/time-log" element={<TimeLog />} />
                        <Route path="/performance" element={<EmployeePerformance />} />
                        <Route path="/salary" element={<Salaries />} /> */}
                        <Route path="/expense" element={<ProtectedRoute><Expenses /></ProtectedRoute>} />
                        <Route path="/lead-old" element={<ProtectedRoute><LeadsUpdated /></ProtectedRoute>} />
                        <Route path="/" element={<ProtectedRoute><LeadsUpdatedVersion /></ProtectedRoute>} />
                        <Route path="/offerings" element={<ProtectedRoute><Offerings /></ProtectedRoute>} />
                        <Route path="/commission" element={<ProtectedRoute><Commission /></ProtectedRoute>} />
                        {/* <Route path="/received-payment" element={<ReceivedPayment />} />
                        <Route path="/due-payment" element={<DuePayment />} />
                        // <Route path="/offerings" element={<Offerings />} />
                        <Route path="/onboarding" element={<Onboarding />} />
                        <Route path="/all-users" element={<AllUsers />} />
                        <Route path="/user-records" element={<UserRecords />} />
                        <Route path="/alluser-records" element={<UserRecordSuper />} />
                        <Route path="/age-group" element={<ClassAgeGroup />} />
                        <Route path="/class-level" element={<ClassLevels />} />
                        <Route path="/class-schedule" element={<ClassSchedule />} />
                        <Route path="/team-department" element={<TeamDepartment />} />
                        <Route path="/team-directory" element={<TeamDirectory />} />
                        <Route path="/team-attendance" element={<TeamAttendance />} />
                        <Route path="/plan" element={<Plan />} />
                        <Route path="/branch" element={<Branch />} />
                        <Route path="/updates" element={<Updates />} /> */}
                        {/* <Route path="/equipments" element={<Equipments />} />
                        <Route path="/expense" element={<Expenses />} />
                        <Route path="/renewals" element={<Renewals />} />
                        <Route path="/category" element={<Category />} />
                        <Route path="/pincode" element={<Pincode />} />
                        <Route path="/delivery" element={<Delivery />} />
                        <Route path="/coupon" element={<Coupon />} />
                        <Route path="/orders" element={<Orders />} /> */}
                        <Route path="/login" element={<Login />} />
                        {/* <Route path="/register" element={<Register />} /> */}
                        {/* <Route path="/add-customer-2" element={<AddCustomer2 />} />
                        <Route path="/location" element={<Location />} />
                        <Route path="/salary-detail" element={<SalaryDetail />} />
                        <Route path="/gallery" element={<Gallery />} /> */}

                        <Route path="/slider" element={<ProtectedRoute><Slider /></ProtectedRoute>} />
                        <Route path="/slider-2" element={<ProtectedRoute><Slider2 /></ProtectedRoute>} />
                        <Route path="/propertyCategory" element={<ProtectedRoute><PropertyCategory /></ProtectedRoute>} />
                        <Route path="/propertyCategory-2" element={<ProtectedRoute><PropertyCategoryUpdate /></ProtectedRoute>} />
                        <Route path="/addproperty" element={<ProtectedRoute><PropertyForm /></ProtectedRoute>} />
                        <Route path="/resident-property/:id" element={<ProtectedRoute><ResidentPropertyEdit /></ProtectedRoute>} />
                        <Route path="/rent-addproperty/:id" element={<ProtectedRoute><ResidentRentEdit /></ProtectedRoute>} />
                        <Route path="/commercial-addproperty/:id" element={<ProtectedRoute><CommercialEdit /></ProtectedRoute>} />
                        <Route path="/feedback" element={<ProtectedRoute><Feedback /></ProtectedRoute>} />
                        <Route path="/schedule" element={<ProtectedRoute><Schedule /></ProtectedRoute>} />
                        <Route path="/resident-addproperty" element={<ProtectedRoute><ResidentPropertyForm /></ProtectedRoute>} />
                        <Route path="/rent-addproperty" element={<ProtectedRoute><RentPropertyForm /></ProtectedRoute>} />
                        <Route path="/commercial-addproperty" element={<ProtectedRoute><CommercialPropertyForm /></ProtectedRoute>} />
                        <Route path="/property" element={<ProtectedRoute><MyProperty /></ProtectedRoute>} />
                        <Route path="/property-2" element={<ProtectedRoute><MyProjectUpdated /></ProtectedRoute>} />
                        <Route path="/amenities" element={<ProtectedRoute><Amenities /></ProtectedRoute>} />
                        <Route path="/amenities-2" element={<ProtectedRoute><AmenitiesUpdatedTable /></ProtectedRoute>} />
                        <Route path="/location-advantage" element={<ProtectedRoute><LocationAdvantage /></ProtectedRoute>} />
                        <Route path="/location-advantage-2" element={<ProtectedRoute><LocationAdvantageUpdated /></ProtectedRoute>} />
                        <Route path="/water-supply" element={<ProtectedRoute><WaterSupply /></ProtectedRoute>} />
                        <Route path="/marquee" element={<ProtectedRoute><Marquee /></ProtectedRoute>} />
                        <Route path="/security" element={<ProtectedRoute><Security /></ProtectedRoute>} />
                        <Route path="/loan-emi-calculator" element={<ProtectedRoute><LoanEMICalculator /></ProtectedRoute>} />
                        <Route path="/department" element={<ProtectedRoute><Department /></ProtectedRoute>} />
                        <Route path="/team-attendance/:name/:id" element={<ProtectedRoute><TeamAttendanceSingle /></ProtectedRoute>} />
                        <Route path="/team-department" element={<TeamDepartment />} />
                        <Route path="/team-directory" element={<TeamDirectory />} />
                        <Route path="/team-attendance" element={<TeamAttendance />} />
                        <Route path="/reset" element={<ResetPassword />} />
                        <Route path="/add-customer" element={<AddCustomer2 />} />
                        <Route path="/edit-customer" element={<AddCustomer3 />} />
                        {/* Add more routes as needed */}
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </div>

            </div>
            <ToastContainer position="top-right" autoClose={3000} style={{ zIndex: 999999 }} />
        </SidebarProvider>
    );
};

export default App;
